import React from 'react';

const ReceiptPageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/receipt/:receiptId',
			exact: true,
			component: React.lazy(() => import('./ReceiptPage')),
		},
	],
};

export default ReceiptPageConfig;
